package com.banyan.flightviewer.platform

import kotlinx.browser.localStorage
import org.w3c.dom.get
import org.w3c.dom.set

/**
 * localStorage-backed implementation. All values are serialized to/from
 * String. flush() is a no-op (localStorage writes are synchronous).
 *
 * Keys are namespaced with a "fv:" prefix to avoid collisions with anything
 * else served from the same origin.
 */
actual class SettingsStore actual constructor() {

    private fun k(key: String) = "fv:$key"

    actual fun getString(key: String): String? = localStorage[k(key)]
    actual fun putString(key: String, value: String) {
        localStorage[k(key)] = value
    }

    actual fun getInt(key: String): Int? = localStorage[k(key)]?.toIntOrNull()
    actual fun putInt(key: String, value: Int) {
        localStorage[k(key)] = value.toString()
    }

    actual fun getDouble(key: String): Double? = localStorage[k(key)]?.toDoubleOrNull()
    actual fun putDouble(key: String, value: Double) {
        localStorage[k(key)] = value.toString()
    }

    actual fun getBoolean(key: String): Boolean? {
        val raw = localStorage[k(key)] ?: return null
        return raw.equals("true", ignoreCase = true)
    }
    actual fun putBoolean(key: String, value: Boolean) {
        localStorage[k(key)] = value.toString()
    }

    actual fun remove(key: String) {
        localStorage.removeItem(k(key))
    }

    actual fun flush() {
        // localStorage is synchronous; nothing to flush.
    }
}
